export default __webpack_public_path__ + "static/media/img1.27a44249.png";